import { type IntlShape } from 'react-intl';

import { getUserRecommendations } from '@atlaskit/smart-user-picker';

import type { ProductKeyType } from '../types.ts';

type GetCreatedByProps = {
	query: string;
	userId: string;
	cloudId: string;
	productKey: ProductKeyType;
	maxNumberOfResults: number;
	intl: IntlShape;
};

export const getCreatedBy: ({
	query,
	userId,
	cloudId,
	productKey,
	maxNumberOfResults,
	intl,
}: GetCreatedByProps) => Promise<import('@atlaskit/user-picker').OptionData[]> = ({
	query,
	userId,
	cloudId,
	productKey,
	maxNumberOfResults,
	intl,
}: GetCreatedByProps) => {
	const requestParams = {
		context: {
			contextType: 'createdBy',
			principalId: userId,
			productAttributes: {
				isEntitledConfluenceExternalCollaborator: true,
			},
			productKey,
			siteId: cloudId,
		},
		includeGroups: false,
		includeTeams: false,
		includeUsers: true,
		maxNumberOfResults,
		performSearchQueryOnly: false,
		query,
	};

	return getUserRecommendations(requestParams, intl);
};
